import { useContext, useMemo } from 'react';
import { LoggerContext } from './LoggerProvider';
import { ClientLogger } from '../ClientLogger';

export const useLogger = (componentName: string) => {
  const { getLogger } = useContext(LoggerContext);
  const logger = useMemo<ClientLogger>(() => getLogger(componentName), []);
  return logger;
};
